import { render } from "./UserContractsTable.vue?vue&type=template&id=4725cfa3&scoped=true"
import script from "./UserContractsTable.vue?vue&type=script&lang=js"
export * from "./UserContractsTable.vue?vue&type=script&lang=js"

import "./UserContractsTable.vue?vue&type=style&index=0&id=4725cfa3&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4725cfa3"]])

export default __exports__